import axios from 'axios';
import { Store } from '../redux/store';
import { showDanger } from '../redux/actions/snackbarActions';

export async function handleErrors(status, errors) {
    if (status === 400) {
        if (!errors.success) {
            const message = [];
            if (errors.data) {
                for (let error of errors.data) {
                    message.push(error.details);
                }
            } else {
                message.push("A error has occurred while attempting to complete this request. Please contact administrator.");
            }
            Store.dispatch(showDanger(message.join(' | ')));
        }
    }
}

export async function get(url, params, configs, onError = null) {
    try {
        const payload = await axios.get(url, { ...configs, params });
        return payload.data;
    } catch (error) {
        if (onError && typeof onError === 'function') {
            onError(error.response);
            return;
        }
        throw error.response;
    }
}

export async function post(url, body, configs, onError = null) {
    try {
        const payload = await axios.post(url, body, configs);
        return payload.data;
    } catch (e) {
        if (onError && typeof onError === "function") {
            onError(e.response);
        }
        throw e.response;
    }
}

export async function put(url, body, configs, onError = null) {
    try {
        const payload = await axios.put(url, body, configs);
        return payload.data;
    } catch (error) {
        if (onError && typeof onError === 'function') {
            onError(error.response);
            return;
        }
        throw error;
    }
}

export async function patch(url, body, configs, onError = null) {
    try {
        const payload = await axios.patch(url, body, configs);
        return payload.data;
    } catch (error) {
        if (onError && typeof onError === 'function') {
            onError(error.response);
            return;
        }
        throw error;
    }
}

export async function deleteRequest(url, params, configs, onError = null) {
    try {
        const payload = await axios.delete(url, { ...configs, params });
        return payload.data;
    } catch (error) {
        if (onError && typeof onError === 'function') {
            onError(error.response);
            return;
        }
        throw error.response;
    }
}